import { useSyncExternalStore } from 'react';

let pending = false;
const listeners = new Set<() => void>();

export function setLanguageLoadPending(value: boolean): void {
  if (pending === value) return;
  pending = value;
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot(): boolean {
  return pending;
}

export function useLanguageLoadPending(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot);
}
